import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as moment from "moment";
import { LocalStorageService } from 'ngx-store';
import { serialize } from 'object-to-formdata';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { Bill, BillItem, BillPayment, BillStatus, BillType } from '../model/bills.model';
//Model
import { Url } from '../model/users.model';



@Injectable()
export class BillsService {
    private url: Url;

  	private headers = new Headers({ 'Content-Type': 'application/json' });
    // Http Headers
    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json'
        })
    }

    constructor(public http: HttpClient, private localStorage: LocalStorageService) {
        this.url = this.localStorage.get('url');
    }

    getBillYearRecords(): Observable<any[]> { 
		return this.http.get<any[]>(this.url.rest + '/tms/getBillYearRecords', this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            ) 
    }

    getDueBills(query_filter = ""): Observable<any[]> { 

        var param = '';
        if (query_filter) {
            param = '/' + query_filter;
        }
        return this.http.get<any[]>(this.url.rest  + '/tms/getDueBills' + param, this.httpOptions)
        .pipe(
          retry(1),
          catchError(this.handleError)
        ) 
		
    }

    getBillStatuses(): Observable<{ bill_statuses: BillStatus[] }> { 
		return this.http.get<{ bill_statuses: BillStatus[] }>(this.url.rest + '/tms/getBillStatuses', this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            ) 
    }

    getBills(): Observable<any[]> { 
		return this.http.get<any[]>(this.url.rest + '/tms/getBills', this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            ) 
    }

    getBillsFiltered(statusFilter = '', dateFilter = '', start = '', end = ''): Observable<any[]> { 
        var param = '';
        if (statusFilter) {
            param = '/' + statusFilter;
            if (dateFilter) {
                param = param + '/' + dateFilter;
                if (dateFilter == 'range') {
                    if (moment(end).isSameOrAfter(moment(start))) {
                        param = param + '/' + start + '/' + end; 
                    }
                } 
            }

        }
        return this.http.get<any[]>(this.url.rest  + '/tms/getBillsFiltered' + param, this.httpOptions)
        .pipe(
          retry(1),
          catchError(this.handleError)
        ) 
      }

    getBillTypes() {
        return this.http.get<BillType[]>(`${this.url.rest}/tms/getBillTypes`)
        .pipe(
            retry(1),
            catchError(this.handleError)
        );
    }

    createBillType(bill_type): Observable<any> {	
    return this.http.post<any>(this.url.rest  + '/tms/createBillType', bill_type , this.httpOptions)
        .pipe(
        retry(1),
        catchError(this.handleError)
        ) 
    }

    deleteBill(bill: Bill): Observable<any> {
        return this.http.post<any>(this.url.rest  + '/tms/deleteBill' , bill, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    getBillPayments(bill_id : number): Observable<any[]> { 
		return this.http.get<any[]>(this.url.rest + '/tms/getBillPayments/' + bill_id, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            ) 
    }

    createBillPayment(bill_payment): Observable<any> {	
        return this.http.post<any>(this.url.rest  + '/tms/createBillPayment', bill_payment , this.httpOptions)
            .pipe(
            retry(1),
            catchError(this.handleError)
            ) 
        }
    
    updateBillPaymentFileName(bill_payment): Observable<any> {	
    return this.http.post<any>(this.url.rest  + '/tms/updateBillPaymentFileName', bill_payment , this.httpOptions)
        .pipe(
        retry(1),
        catchError(this.handleError)
        ) 
    }

    deleteBillPayment(payment: BillPayment): Observable<any> {
        return this.http.post<any>(this.url.rest  + '/tms/deleteBillPayment' , payment, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    updateBillPayment(bill_payment): Observable<any> {	
        return this.http.post<any>(this.url.rest  + '/tms/updateBillPayment', bill_payment , this.httpOptions)
            .pipe(
            retry(1),
            catchError(this.handleError)
            ) 
    }

    getBillDetails(bill_id : number): Observable<{
        bill: Bill[],
        items: BillItem[],
        types: BillType[],
        statuses: BillStatus[]
    }> { 
		return this.http.get<any>(this.url.rest + '/tms/getBillDetails/' + bill_id, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            ) 
    }

    getBillNotes(bill_id : number): Observable<any[]> { 
		return this.http.get<any[]>(this.url.rest + '/tms/getBillNotes/' + bill_id, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            ) 
    }

    createBillNote(note: any): Observable<any> {
        return this.http.post<any>(this.url.rest  + '/tms/createBillNote', note, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    deleteBillNote(note: any): Observable<any[]> {
        return this.http.post<any[]>(this.url.rest  + '/tms/deleteBillNote' , note , this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    getBillHistory(bill_id : number): Observable<any[]> { 
		return this.http.get<any[]>(this.url.rest + '/tms/getBillHistory/' + bill_id, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            ) 
    }


    markBillPaid(bill): Observable<any> {	
        return this.http.post<any>(this.url.rest  + '/tms/markBillPaid', bill , this.httpOptions)
            .pipe(
            retry(1),
            catchError(this.handleError)
            ) 
    }

    markBillPending(bill): Observable<any> {	
        return this.http.post<any>(this.url.rest  + '/tms/markBillPending', bill , this.httpOptions)
            .pipe(
            retry(1),
            catchError(this.handleError)
            ) 
    }

    markBillCancelled(bill): Observable<any> {	
        return this.http.post<any>(this.url.rest  + '/tms/markBillCancelled', bill , this.httpOptions)
            .pipe(
            retry(1),
            catchError(this.handleError)
            ) 
    }

    deleteBillFile(file: any): Observable<any[]> {
        return this.http.post<any[]>(this.url.rest  + '/tms/deleteBillFile' , file , this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    getBillFiles(bill_id:number): Observable<any[]> {
        return this.http.get<any[]>(this.url.rest  + '/tms/getBillFiles/' + bill_id , this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    createBillFile(file: any): Observable<any[]> {
        return this.http.post<any[]>(this.url.rest  + '/tms/createBillFile' , file , this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    getBillExpenseRecordByQuery(bill_item_id:number, table_name : string): Observable<any[]> {
        return this.http.get<any[]>(this.url.rest  + '/tms/getBillExpenseRecordByQuery/' + bill_item_id + '/' +  table_name, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    getExpenseRecords(bill_item_id:number): Observable<any[]> {
        return this.http.get<any[]>(this.url.rest  + '/tms/getExpenseRecords/' + bill_item_id , this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }
        
    createBill(bill: Bill) {
        let formData = serialize(bill, { indices: true });

        return this.http
            .post<Bill>(`${this.url.rest}/tms/bills`, formData)
            .pipe(
                retry(1),
                catchError(this.handleError)
            );
    }

    updateBill(bill: Bill) {
        // see: https://github.com/laravel/framework/issues/13457#issuecomment-239451567
        bill['_method'] = 'PUT';

        let formData = serialize(bill, { indices: true });

        return this.http
            .post<Bill>(
                `${this.url.rest}/tms/bills/${bill.id}`,
                formData
            )
            .pipe(
                retry(1),
                catchError(this.handleError)
            );
    }

    getBillTablesByBillType(bill_type_id : number): Observable<any[]> {
        return this.http.get<any[]>(this.url.rest  + '/tms/getBillTablesByBillType/' + bill_type_id , this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    getTableImportableRecords(params): Observable<any[]> {
        return this.http.post<any[]>(this.url.rest  + '/tms/getTableImportableRecords' , params , this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    // Error handling
    handleError(error) {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
            // Get client-side error
            errorMessage = error.error.message;
        } else {
            // Get server-side error
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        console.log(errorMessage);
        return throwError(errorMessage);
    }
}